import { AdvancedOneCustomerFilters } from "src/app/config/GlobalCacheLoader.service";
import { ContractModel } from "src/app/global/contract-filter-model";
import { Money } from "src/app/global/types";

//#region types that reflect data structure from backend api
export type SolutionParticipationSummaryData = {
  solution: string;
  compliant: string;
  nonCompliant: string;
  productCount: number;
  compliantCount: string;
  nonCompliantCount: string;
};

export type SolParticipationSummary = {
  solutionParticipationSummary: SolutionParticipationSummaryData[];
  solutionParticipationSolutionsPerLocationAvg: number;
};

export type SolutionParticipationSummaryCells = {
  sgCell: SolutionGroupCell;
  lcCell: LocationComplianceCell;
  trendCell: SalesTrendCell;
};

export type SolutionParticipationSalesData = {
  solution: string;
  totalSales: number;
  salesTrends: SaleByMonth[];
};

export type SolutionParticipationCasesData = {
  solution: string;
  totalCases: number;
  casesTrends: CasesByMonth[];
};

export type SaleByMonth = {
  month: string;
  year: string;
  saleByMonth: number;
};

export type CasesByMonth = {
  month: string;
  year: string;
  caseByMonth: number;
};
//#endregion

//#region types that are used in components and the table rows
export type SolutionGroupCell = {
  name: string;
  numOfProducts: string | number;
};

export type LocationComplianceCell = {
  compliance: string;
  nonCompliance: string;
  complianceCount: string | number;
  nonComplianceCount: string | number;
  totalCount: string | number;
};

export type SalesTrendCell = {
  xAxisCategories: string[];
  yAxisCategories: any[];
};

export type SolutionParticipationTableRow = {
  SolutionGroup: SolutionGroupCell;
  LocationComplianceCell: LocationComplianceCell;
  Sales: number;
  SalesTrend: SalesTrendCell;
  ShowLinksToViewBy: boolean; //for UI/UX purposes, not sure how to best achieve the functionality
  Opportunity: number;
};
//#endregion

//#region groupBy location/product page types


export type locationViewData = {
  totalUsageLocationCount: number;
  totalNonUsageLocationCount: number;
  locations:groupByLocation[];
};

export type groupByLocation = {
  mdmSiteId: string;
  siteName: string;
  address: string;
  city: string;
  state: string;
  country: string;
  postalAddress: string;
  totalSales: Money;
  totalCases: number;
  accountNumber:string;
  territoryReps: string[];
  districtManagers: string[];
  areaManagers: string[];
  productInfo:SolutionParticipationProductInfo[],
  isNonUsageLocations: boolean;
  accountCount: number;
  productCount:number;
};

export type  SolutionParticipationProductInfo = {
  productCode: string;
  productName: string;
};

  export type ExcelRow = {
    'Site number': string;
    'Site name': string;
    'Site Address line 1': string;
    'Site City': string;
    'Site State': string;
    'Site Country': string;
    'Site Zip Code': string;
    'Account number': string;
    'Product name': string;
    'Solution Group': string | undefined;
    'Product sku/code': string;
    'Product Sales Summary': string;
    'Cases': number | "N/A";
    'Territory Rep': string;
    'District Manager': string;
    'Area Manager': string;
  }
//#endregion



export type SolutionParticipationAccountInfo = {
  'accountName': string,
  'accountNumber': string,
}
export type groupByProducts = {
  productName: string;
  productCode: string;
  totalSalesAmount: Money;
  totalSalesQuantity: number;
  totalAccountCount: number;
  accountInfo:SolutionParticipationAccountInfo[];
};

export type products = {
  totalCount: number;
  products:groupByProducts[];
};

export type solutionParticipationSummaryFilter = {
  platform: string;
  solution: string;
  productGroup: string;
  productName: string;
  brand: string;
  productSku: string;
};

export type SPSummaryFilterOptions = {
  platform: string[];
  solution: string[];
  productGroup: string[];
  productName: string[];
  productSku : string[];
  brand: string[];
};

export type solutionParticipationProductFilter = {
  accountNumber: string;
  accountName: string;
  country: string;
  state: string;
  city: string;
  zipCode: string;
  productSku: string;
  brand: string;
  productGroup: string;
  productName:string;
};

export type SPProductFilterOptions = {
  accountNumber: string[];
  accountName: string[];
  country: string[];
  state: string[];
  city: string[];
  zipCode: string[];
  productSku: string[];
  brand: string[];
  productGroup?: string[];
  productName?: string[];
};

export type SiteProductData = {
  mdmSiteId: string;
  siteName: string;
  address: string;
  city: string;
  state: string;
  country: string;
  postalAddress: string;
  productName: string;
  productCode: string;
  siteSalesAmount: number;
  siteSalesQty: number;
  accountNumber: string;
};


export type ProductExcelRow = {
  'Product Name': string;
  'Product Code/SKU':string;
  'Account Number': string;
  'Account Name':string;
  'Account address':string;
  'Account City':string;
  'Account State':string;
  'Account Country':string;
  'Account Zip Code':string;
  'Product Sales Summary': string;
  'Solution Group': string;
  'Cases': number;
  'Territory Rep': string,
  'District Manager': string,
  'Area Manager': string,
}

export type SPViewFilterOptions = SPProductFilterOptions & {
  productGroup: string[];
  productName: string[];
};

export type SPLocationTotalSolutionGroupsExpandedData = {
  siteId: string;
  totalSolutionGroups: number;
  solutionGroups: SPLocationExpandedSolutionGroup[];
};

export type SPLocationExpandedSolutionGroup = {
  countOfProducts: number;
  otherDistributor: string;
  solutionGroup: string;
  totalSalesAmt: number;
  isPurchased: boolean;
  products: SPLocationExpandedProduct[];
};

export type SPLocationExpandedProduct = {
  productCode: string;
  productName: string;
  distributorProduct: string;
  rebate: number;
  mpl: number;
  spl: number;
  lastPurchased: string;
  isPurchased: boolean;
};

export interface CallTypeConfig {
  [key: string]: {
    types: string[];
    labels?: { [key: string]: string };
    colors: string[];
  }
}

export type PaginationOptions = {
  limit: number,
  page: number,
  sortBy: string,
  sortOrder: string
  tabSelected: string,
  searchTerm?: string
}

export interface SPGroupLocation {
  siteId: string;
  siteName: string;
  address: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  count: number;
  greenCount: number;
  compliance: number;
  solutions: { [key: string]: SPGroupStatusDetails };
  territoryRep: string;
  districtManager: string;
  areaManager: string;
}

export interface SPGroupStatusDetails {
  status: string;
  cases: string;
  sales: string;
}

export interface SPGroupLocationsResponse {
  totalCount: number;
  solutionGroups: string[];
  spGroupLocations: SPGroupLocation[];
}

export interface SortOptions {
  sortDirections: { [key: string]: string };
  sortBy: string; // The field by which sorting is done
  sortDirection: string;
}


// Add widget data model for subscription
export interface SPRebateWidgetData {
  totalLocations: number;
  totalCompliantLocations: number;
  complianceTarget: number | null;
  solutionGroups: string[];
}

export interface SPProductWidgetData {
  totalLocations: number;
  avgProductListPurchased: number;
  productListCount: number;
  productListType: string;
}

export type WidgetType = 'all' | 'spl' | 'mpl' | 'rebate';

export interface DonutWidgetConfig {
  responsive?: boolean,
  maintainAspectRatio?: boolean,
  padding?: {
    top: number,
    bottom: number,
    left: number,
    right: number
  }
}

export interface SpProductOrLocationExportPayload{
  exportType: string;
  contractModel:ExtendedContractModel | undefined;
  queryFilters: QueryFilter[];
  searchTerm?: string; // Optional string for search term
  oneCustomerName?: string;
  oneCustomerFilters?: AdvancedOneCustomerFilters;
}

export class ExtendedContractModel extends ContractModel {
  currencyCode?: string;
  unitOfMeasure?: string;
}

export interface QueryFilter {
    columnFilters: Record<string, any>; // Equivalent to IDictionary<string, object>
    logicalOperator:"And" | "Or"; // Optional string limited to specific values
    filterOperation:  "In" | "Not In" | "Equals" | "ILike" | "=" | "!="; // Optional limited string
}


export enum AccountHierarchyStatus {
  LinkedToMultipleHierarchies = "LinkedToMultipleHierarchies",
  NotLinkedToMultipleHierarchies = "NotLinkedToMultipleHierarchies"
}

export interface AccountHierarchyResponse {
  status: AccountHierarchyStatus;
  isShowMessage: boolean;
}
